/**
 * JWT Token Decoder Utility
 * Decodes JWT token to extract claims (roles, privileges, etc.)
 * TODO: Privileges will be implemented later
 */

export const decodeJWT = (token) => {
  try {
    if (!token) return null;

    // JWT has 3 parts: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    // Decode the payload (second part)
    const payload = parts[1];
    
    // Replace URL-safe base64 characters
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    
    // Decode base64
    const decoded = atob(base64);
    
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

export const getClaimsFromToken = (token) => {
  const decoded = decodeJWT(token);
  if (!decoded) return { roles: [], privileges: [] };

  // Extract roles from claims
  const roles = [];
  if (decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']) {
    const roleClaim = decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    roles.push(...(Array.isArray(roleClaim) ? roleClaim : [roleClaim]));
  }

  // TODO: Privileges will be implemented later
  // Extract privileges from claims
  // const privileges = [];
  // if (decoded.Privilege) {
  //   privileges.push(...(Array.isArray(decoded.Privilege) ? decoded.Privilege : [decoded.Privilege]));
  // }
  const privileges = []; // Empty for now

  return {
    userId: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] || decoded.UserId,
    userName: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] || decoded.UserName,
    email: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'] || decoded.Email,
    roles,
    privileges,
    exp: decoded.exp,
    iat: decoded.iat
  };
};

// TODO: Privileges will be implemented later
// export const hasPrivilege = (token, privilegeCode) => {
//   const claims = getClaimsFromToken(token);
//   return claims.privileges.includes(privilegeCode);
// };

// export const hasAnyPrivilege = (token, privilegeCodes) => {
//   if (!Array.isArray(privilegeCodes)) return false;
//   const claims = getClaimsFromToken(token);
//   return privilegeCodes.some(code => claims.privileges.includes(code));
// };

// export const hasAllPrivileges = (token, privilegeCodes) => {
//   if (!Array.isArray(privilegeCodes)) return false;
//   const claims = getClaimsFromToken(token);
//   return privilegeCodes.every(code => claims.privileges.includes(code));
// };

export const hasRole = (token, roleCode) => {
  const claims = getClaimsFromToken(token);
  return claims.roles.includes(roleCode);
};


